<template>
  <v-dialog v-model="dialogApprove" persistent max-width="1000px" width="668" :retain-focus="false">
      <v-card tile class="pt-4 pl-10 pr-10 pb-4" min-height="auto">
        <v-divider
            inset
            vertical
          ></v-divider>
        <div class="">
          <span class="black--text font-weight-bold mr-5">ข้อมูลการอนุมัติ</span>
          <v-chip
            v-if="statusForApprove=='pending'"
            small
            :color="'#ECF9FF'"
            text-color="#00B0FF"
          >
            <span>กำลังดำเนินการ</span>
          </v-chip>
          <v-chip
            v-else-if="statusForApprove=='waiting'"
            small
            :color="'#FEF5E9'"
            text-color="#E9A016"
          >
            <span>รออนุมัติ</span>
          </v-chip>
          <v-chip
            v-else-if="statusForApprove=='approve'"
            small
            :color="'#ECF8EA'"
            text-color="#58A144"
          >
            <span>อนุมัติแล้ว</span>
          </v-chip>
          <v-chip
            v-else-if="statusForApprove=='acknowledge'"
            small
            :color="'#ECF8EA'"
            text-color="#58A144"
          >
            <span>รับทราบแล้ว</span>
          </v-chip>
          <v-chip
            v-else-if="statusForApprove=='cancel'"
            small
            :color="'#EEEEEE'"
            text-color="#999999"
          >
            <span>ยกเลิกคำร้องขอใช้บริการ</span>
          </v-chip>
          <v-chip
            v-else
            small
            :color="'#FBE5E4'"
            text-color="#D1392B"
          >
            <span>ไม่อนุมัติ</span>
          </v-chip>
          <v-btn absolute right top icon x-small @click="closeDialogApprove"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-divider class="mt-4 mb-4"/>
        <v-row style="margin-top: -14px;">
          <v-col cols="12" lg="5" md="6" sm="6">
            <pre class="ra-head-text-gray">หมายเลขคำร้อง</pre>
            <pre class="ra-head-text black--text">{{ formId }}</pre>
          </v-col>
          <v-col cols="12" lg="7" md="6" sm="6">
            <pre class="ra-head-text-gray">ประเภทคำร้อง</pre>
            <pre class="ra-head-text black--text">{{ serviceType }}</pre>
          </v-col>
          <v-col cols="12" lg="5" md="6" sm="6">
            <pre class="ra-head-text-gray">ชื่อ Service</pre>
            <pre class="ra-head-text black--text  text-wrap">{{ serviceName }}</pre>
          </v-col>
          <v-col cols="12" lg="7" md="6" sm="6">
            <pre class="ra-head-text-gray">วันที่ร้องขอ</pre>
            <pre class="ra-head-text black--text  text-wrap">{{ dataCreate }}</pre>
          </v-col>
          <v-col cols="12" lg="12" md="12" sm="12">
            <pre class="ra-head-text-gray">หมายเหตุ</pre>
            <pre class="ra-head-text black--text  text-wrap">{{ note || '-' }}</pre>
          </v-col>
        </v-row>
        <v-row v-if="showRequestBy">
          <v-col cols="12">
            <pre class="ra-head-text-gray">ข้อมูลพนักงาน</pre>
          </v-col>
          <v-col cols="12">
            <v-card
              class="user-data-panel"
              style="margin-top: -14px;"
              outlined
            >
            <v-row class="pl-1 pr-1 pt-0">
                <v-col cols="12" sm="2" md="2" lg="2" class="">
                  <v-avatar
                    class="ml-3 mt-1"
                    :size="$vuetify.breakpoint.name !== 'lg'? '70':'70'"
                    rounded
                  >
                  <v-img
                    cover
                    :lazy-src="require('@/assets/icons/no_user.png')"
                    :src="this.userImg? this.userImg : require('@/assets/icons/no_user.png')"
                  >
                  </v-img>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="10" md="10" lg="10" style="margin-top: -10px; margin-bottom: -10px;">
                  <v-row>
                    <v-col cols="12" lg="6" md="6" sm="6" v-if="requestEmployeeId && requestEmployeeId !== '-'">
                      <pre class="ra-head-text-gray">รหัสพนักงาน</pre>
                      <pre class="ra-head-text black--text">{{ requestEmployeeId }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6">
                      <pre class="ra-head-text-gray">ชื่อ - นามสกุล</pre>
                      <pre class="ra-head-text black--text">{{ requestName }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6">
                      <pre class="ra-head-text-gray">อีเมล</pre>
                      <pre class="ra-head-text black--text">{{ requestEmail }}</pre>
                    </v-col>
                    <!-- <v-col cols="12" lg="6" md="6" sm="6" v-if="lineofwork && lineofwork !== '-'">
                      <pre class="ra-head-text-gray">สายงาน</pre>
                      <pre class="ra-head-text black--text">{{ lineofwork }}</pre>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6" v-if="department && department !== '-'">
                      <pre class="ra-head-text-gray">ฝ่ายงาน</pre>
                      <pre class="ra-head-text black--text">{{ department }}</pre>
                    </v-col> -->
                    <v-col cols="12" lg="6" md="6" sm="6">
                      <pre class="ra-head-text-gray">ตำแหน่ง</pre>
                      <pre class="ra-head-text black--text">{{ requestPosition }}</pre>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <pre class="ra-head-text black--text font-weight-bold">ลำดับการอนุมัติ</pre>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-timeline
              class="user-data-panel"
              style="margin-top: -14px;"
              align-top
              dense
            >
              <v-timeline-item
                v-for="item in approveBy"
                :key="item.no"
                :color="item.statusApprove=='pending' || item.statusApprove=='waiting' ? '#E0EAFB':'#3776E9'"
                small
                fill-dot
              >
                <template v-slot:icon>
                  <span :class="item.statusApprove=='pending' || item.statusApprove=='waiting' ? 'blue--text':'white--text'">
                    {{ approveBy.indexOf(item)+1 }}
                  </span>
                </template>
                <v-row style="margin-top: -12px;">
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <pre class="ra-head-text font-weight-bold">{{ item.approverName }}</pre>
                    <pre class="ra-head-text-gray">{{ item.approverEmail || '' }}</pre>
                    <pre class="ra-head-text-gray">{{ item.position || ''  }}</pre>
                    <pre v-if="item.approveComment && item.approveComment !== '-'" class="ra-head-text black--text text-wrap" style="width: calc(100% + 0px);">ความเห็น : {{ item.approveComment }}</pre>
                    <pre v-else class="ra-head-text black--text"></pre>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <v-row class="ml-0">
                    <v-chip
                      v-if="item.status=='pending'"
                      small
                      :color="'#FEF5E9'"
                      text-color="#E9A016"
                    >
                      <span>รออนุมัติ</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.status=='approve'"
                      small
                      :color="'#ECF8EA'"
                      text-color="#58A144"
                    >
                      <span>{{ item.approveByAdmin? 'อนุมัติโดย แอดมิน':'อนุมัติแล้ว' }}</span>
                    </v-chip>
                    <v-chip
                      v-else-if="(item.status=='acknowledge' || item.status=='approve')"
                      small
                      :color="'#ECF8EA'"
                      text-color="#58A144"
                    >
                      <span>{{ item.approveByAdmin? 'รับทราบโดย แอดมิน':'รับทราบแล้ว' }}</span>
                    </v-chip>
                    <v-chip
                      v-else-if="item.status=='reject'"
                      small
                      :color="'#FBE5E4'"
                      text-color="#D1392B"
                    >
                      <span>{{ item.approveByAdmin? 'ไม่อนุมัติโดย แอดมิน':'ไม่อนุมัติ' }}</span>
                    </v-chip>
                    </v-row>
                    <v-row class="mt-4 ml-0" style="padding-left: 5px;">
                    <p class="ra-head-text-gray">
                      <!-- {{ item.approveDate? initDate(item.approveDate):''}} -->
                      {{ item.approveDate || '' }}
                    </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn v-if="statusForApprove === 'pending' && mode ==='approve'" class="mr-0 create-orgchart-header-cancel-btn" color="red accent-2" dark @click="clickReject()">ไม่อนุมัติ</v-btn>
          <v-btn v-if="statusForApprove === 'pending' && mode ==='approve'" class="mr-0 create-orgchart-header-cancel-btn" color="green darken-2" dark @click="clickApprove()">อนุมัติ</v-btn>
          <v-btn v-if="statusForApprove === 'pending' && mode ==='acknowledge'" class="mr-0 create-orgchart-header-cancel-btn" color="green darken-2" dark @click="clickApprove()">รับทราบ</v-btn> -->
          <v-btn v-if="statusForCancel === 'pending' && !showRequestBy" outlined class="mr-4" color="primary" dark @click="cancelService()">ยกเลิกคำร้องขอใช้บริการ</v-btn>
          <!-- <v-btn v-if="statusForTransfer === 'pending'" class="ma-2 create-orgchart-header-cancel-btn" color="purple" dark @click="openDialogTransferPermission()">โอนย้ายสิทธิ์</v-btn> -->
          <v-btn elevation="0" class="font-weight-thin" color="primary" dark @click="closeDialogApprove">ปิด</v-btn>
        </v-card-actions>
      </v-card>
      <DialogTransferPermission/>
    </v-dialog>
</template>

<script>
import { getDetailRequest, approverService, cancleService, hostImageUrlv3 } from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import moment from 'moment'
import DialogTransferPermission from './dialogTransferPermission'
export default {
  components: {
    DialogTransferPermission
  },
  data () {
    return {
      dialogApprove: false,
      failed_image: false,
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      requestStatus: '',
      statusForApprove: '',
      statusForTransfer: '',
      statusForCancel: '',
      requestId: '',
      img: '',
      userId: '',
      messages: [
        {
          from: 'นายสมพงษ์ ครับ',
          message: 'เห็นสมควรได้อนุมัติ',
          time: '10:42am',
          color: 'deep-purple lighten-1'
        },
        {
          from: 'นายสมปอง ครับ',
          message: 'เห็นสมควรได้อนุมัติ',
          time: '10:37am',
          color: 'green'
        },
        {
          from: 'นายสมหมาย ครับ',
          message: 'เห็นสมควรได้อนุมัติ',
          time: '9:47am',
          color: 'deep-purple lighten-1'
        }
      ],
      approveBy: [],
      showRequestBy: false,
      requestEmployeeId: '',
      requestName: '',
      requestPosition: '',
      requestEmail: '',
      userImg: ''
    }
  },
  mounted () {
    EventBus.$on('opendialogMyRequestDetail', this.getMyRequestDetail)
    EventBus.$on('opendialogRequestDetail', this.getRequestDetail)
  },
  beforeDestroy () {
    EventBus.$off('opendialogShowRequestService')
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    this.img = this.api + 'uploads/users_img/no_user.jpg'
  },
  methods: {
    // openDialogApprove (value, item) {
    // },
    onImgError (i) {
      this.messages[i].failed_image = true
    },
    openDialogTransferPermission () {
      // console.log('openDialogTransferPermission Start')
      EventBus.$emit('openDialogTransferPermission', true, this.userId, this.requestId)
    },
    closeDialogApprove () {
      this.dialogApprove = false
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    },
    async getMyRequestDetail (value, item) {
      this.showRequestBy = false
      this.dialogApprove = value
      this.serviceType = item.serviceType
      this.serviceName = item.serviceName
      this.note = ''
      this.formId = item.serviceNo
      this.senderName = item.requestByName
      this.dataCreate = item.requestDate
      this.requestId = item._id
      this.userId = item.userId
      this.loading = true
      var temp = []
      const obj = {
        serviceId: this.requestId
      }
      try {
        const res = await getDetailRequest(obj, this.$store.state.token)
        if (res.success) {
          this.requestStatus = res.result[0].requestStatus
          this.statusForApprove = res.result[0].statusForApprove
          this.statusForTransfer = res.result[0].statusForTransfer
          this.statusForCancel = res.result[0].statusForCancel
          this.note = res.result[0].comment
          // temp = res.result[0].approver
          res.result[0].approver.map((el, index) => {
            // el.approveImg = this.api + '/' + el.approveImg
            if (el.approveDate === '' || el.approveDate === null) {
              el.approveDate = ''
            } else {
              el.approveDate = this.initDate(el.approveDate)
            }
            if (el.approveImg === '') {
              el.approveImg = `${hostImageUrlv3}/_/${el.emailOneId}`
            } else {
              el.approveImg = `${hostImageUrlv3}/${el.approveImg}/${el.emailOneId}`
            }
            if (el.status === 'pending') {
              temp.push({
                no: index + 1,
                requestStatus: 'รอการอนุมัติ',
                color: 'yellow',
                failed_image: false,
                ...el
              })
            } else if (el.status === 'reject') {
              temp.push({
                no: index + 1,
                requestStatus: 'ไม่อนุมัติ',
                color: 'red',
                failed_image: false,
                ...el
              })
            } else {
              temp.push({
                no: index + 1,
                requestStatus: 'อนุมัติ',
                color: 'green',
                failed_image: false,
                ...el
              })
            }
          })
          this.approveBy = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getRequestDetail (value, item) {
      this.userImg = ''
      this.showRequestBy = true
      this.dialogApprove = value
      this.serviceType = item.serviceType
      this.serviceName = item.serviceName
      this.note = ''
      this.formId = item.serviceNo
      this.senderName = item.requestByName
      this.dataCreate = item.requestDate
      this.requestId = item._id
      this.userId = item.userId
      this.loading = true
      var temp = []
      const obj = {
        serviceId: this.requestId
      }
      try {
        const res = await getDetailRequest(obj, this.$store.state.token)
        if (res.success) {
          this.requestStatus = res.result[0].requestStatus
          this.statusForApprove = res.result[0].statusForApprove
          this.statusForTransfer = res.result[0].statusForTransfer
          this.statusForCancel = res.result[0].statusForCancel
          this.note = res.result[0].comment
          this.requestEmployeeId = res.result[0].requestEmployeeId || ''
          this.requestName = res.result[0].requestName
          this.requestPosition = res.result[0].requestPosition
          this.requestEmail = res.result[0].requestEmail
          this.userImg = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
          res.result[0].approver.map((el, index) => {
            if (el.approveDate === '' || el.approveDate === null) {
              el.approveDate = ''
            } else {
              el.approveDate = this.initDate(el.approveDate)
            }
            if (el.approveImg === '') {
              el.approveImg = `${hostImageUrlv3}/_/${el.emailOneId}`
            } else {
              el.approveImg = `${hostImageUrlv3}/${el.approveImg}/${el.emailOneId}`
            }
            if (el.status === 'pending') {
              temp.push({
                no: index + 1,
                requestStatus: 'รอการอนุมัติ',
                color: 'yellow',
                failed_image: false,
                ...el
              })
            } else if (el.status === 'reject') {
              temp.push({
                no: index + 1,
                requestStatus: 'ไม่อนุมัติ',
                color: 'red',
                failed_image: false,
                ...el
              })
            } else {
              temp.push({
                no: index + 1,
                requestStatus: 'อนุมัติ',
                color: 'green',
                failed_image: false,
                ...el
              })
            }
          })
          this.approveBy = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async confirmApprove (status) {
      swal('ต้องการอนุมัติเอกสารนี้ ใช่หรือไม่?', `เลขที่เอกสาร: ${this.formId}`, 'warning', {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      }).then(async (comment) => {
        if (comment) {
          this.loading = true
          var approveList = [{
            requestStatus: status,
            _id: this.requestId,
            comment: this.note
          }]
          const obj = {
            approveList: approveList
          }
          try {
            const res = await approverService(obj, this.$store.state.token)
            if (res.success) {
              // this.dialogApprove = true
              swal('สำเร็จ', 'เอกสารฉบับนี้ ได้รับการอนุมัติแล้ว', 'success', {
                button: false,
                timer: 2000
              })
              this.closeAndSearch()
            }
          } catch (error) {
            swal('ผิดพลาด', 'ไม่สำเร็จ!', 'error')
            console.log(error)
          } finally {
            this.loading = false
          }
        } else if (comment !== null && comment.trim() === '') {
          swal('', 'กรุณาระบุความเห็น', 'warning', {
            button: false,
            timer: 1000
          }).then(() => {
            this.confirmReject(status)
          })
        }
      })
    },
    async confirmReject (status) {
      swal('ไม่ต้องการอนุมัติเอกสารนี้ ใช่หรือไม่?', `เลขที่เอกสาร: ${this.formId}`, '', {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then(async (comment) => {
          if (comment) {
            this.loading = true
            var approveList = [{
              requestStatus: status,
              _id: this.requestId,
              comment: this.note
            }]
            const obj = {
              approveList: approveList
            }
            try {
              const res = await approverService(obj, this.$store.state.token)
              if (res.success) {
                swal('สำเร็จ', 'เอกสารฉบับนี้ ไม่ได้รับการอนุมัติ', 'success', {
                  button: false,
                  timer: 2000
                })
                this.closeAndSearch()
              }
            } catch (error) {
              swal('ผิดพลาด', 'ไม่สำเร็จ!', 'error')
              console.log(error)
            } finally {
              this.loading = false
            }
          } else if (comment !== null && comment.trim() === '') {
            swal('', 'กรุณาระบุความเห็น', 'warning', {
              button: false,
              timer: 1000
            }).then(() => {
              this.confirmReject(status)
            })
          }
        })
    },
    async cancelService () {
      swal('ต้องการยกเลิกคำขอเอกสารนี้ ใช่หรือไม่?', `เลขที่เอกสาร: ${this.formId}`, '', {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'ความเห็น',
            type: 'text'
          }
        },
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then(async (comment) => {
          if (comment) {
            const obj = {
              serviceId: this.requestId
            }
            try {
              const res = await cancleService(obj, this.$store.state.token)
              if (res.success) {
                swal('สำเร็จ', 'ยกเลิกคำขอ สำเร็จ', 'success', {
                  button: false,
                  timer: 2000
                })
                this.closeAndSearch()
              }
            } catch (error) {
              console.log(error)
              swal('ผิดพลาด', 'ยกเลิกคำขอ ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 2000
              })
            } finally {
              this.loading = false
            }
          } else if (comment !== null && comment.trim() === '') {
            swal('', 'กรุณาระบุความเห็น', 'warning', {
              button: false,
              timer: 1000
            }).then(() => {
              this.cancelService()
            })
          }
        })
    },
    async closeAndSearch () {
      this.dialogApprove = false
      EventBus.$emit('requestServiceSearch')
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

img {
  width: 100%;
  height: auto;
  margin-top: -10%;
  /* position: absolute; */
  z-index: auto;
}

.v-timeline::before {
    top: 24px;
    height: calc(100% - 125px)
}
</style>
